import salesforceApi from "@/api/salesforce";

export default {
  actions: {
    async get({ commit, state }, id) {
      const record = await salesforceApi.get(id);
      commit("setRecord", record);
      return state.record;
    },
    async list({ commit, state }, reload) {
      if (state.list.length && !reload) {
        return state.list;
      }
      const list = await salesforceApi.list();
      return commit("setList", list);
    },
  },
  getters: {
    getById: state => findId => {
      return state.list.find(item => {
        return item.salesforceId === findId;
      });
    },
  },
  mutations: {
    setList(state, list) {
      state.list = list;
    },
    setRecord(state, record) {
      state.record = record;
    },
  },
  namespaced: true,
  state: {
    list: [],
    record: {},
  },
};
